import { render } from "./KeyboardKey.vue?vue&type=template&id=6b3b779b&ts=true"
import script from "./KeyboardKey.vue?vue&type=script&lang=ts"
export * from "./KeyboardKey.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__